import { $window } from '../Constants';
import HtmlElement from './HtmlElement';

/**
 * Nav
 */
const Nav = (() => {
  // Constants
  const DATA_KEY = 'ig.nav';
  const EVENT_KEY = `.${DATA_KEY}`;

  /**
   * Selector
   */
  const Selector = {
    SUB_LEVELS: 'ul ul'
  };

  /**
   * ClassName
   */
  const ClassName = {
    POS_RIGHT: 'pos-right'
  };

  /**
   * Event
   */
  const Event = {
    RESIZE: `resize${EVENT_KEY}`
  };

  /**
   * Nav
   *
   * @class
   * @augments HtmlElement
   */
  class Nav extends HtmlElement {
    // Public

    /**
     * Handles ready event
     *
     * @return void
     */
    onReady() {
      this._$subNavLevels = this._getSubNavLevels();
      super.onReady();

      this._bindHandlers();
      this._positionSubLevels();
    }

    // Private

    /**
     * Binds the event handlers to the elements
     *
     * @return void
     */
    _bindHandlers() {
      $window.on(Event.RESIZE, () => {
        this._positionSubLevels();
      });
    }

    /**
     * Returns the sub nav levels
     *
     * @return { jQuery }
     */
    _getSubNavLevels() {
      return this.$element.find(Selector.SUB_LEVELS);
    }

    /**
     * Positions the sub levels
     *
     * @return void
     */
    _positionSubLevels() {
      this._$subNavLevels.each((i, el) => {
        let $level = $(el),
            rightSide = ($level.offset().left + $level.width() > $window.width());

        $level.toggleClass(ClassName.POS_RIGHT, rightSide);
      });
    }
  }

  return Nav;
})();

export default Nav;
